export default __webpack_public_path__ + "static/media/map3.0748b511.png";